<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="false"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="search-form">
      <div @keyup.enter="handleSearch">
        <el-form-item class="search-form-item" :label="$t('lang.SN码')">
          <el-input :placeholder="$t('lang.SN码')" v-model="searchForm.sn" clearable></el-input>
        </el-form-item>

        <el-form-item class="search-form-item" label="">
          <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{ $t('lang.搜索') }}</el-button>
          <el-button size="mini" @click="handleReset">{{ $t('lang.重置') }}</el-button>
        </el-form-item>
      </div>
    </template>

    <template slot="table">
      <el-table :data="tableData">
        <el-table-column type="index" width="50" :label="$t('lang.序号')"></el-table-column>
        <el-table-column prop="sn" :label="$t('lang.SN码')"></el-table-column>
        <el-table-column prop="recipeNumber" :label="$t('lang.食谱编号')"></el-table-column>
        <el-table-column prop="recipeName" :label="$t('lang.食谱名称')"></el-table-column>
        <el-table-column prop="recipeLang" :label="$t('lang.食谱语言')"></el-table-column>
        <el-table-column prop="recipeType" :label="$t('lang.类型')">
          <template v-slot="{row}">
            {{ row.recipeType | recipeType(that) }}
          </template>
        </el-table-column>
      </el-table>
    </template>

  </fb-list-body>
</template>

<script>

export default {
  name: "FavoriteRecipeList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.recipeCollect.list,
      },
      searchForm: {},
      tableData: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      that: this,
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    }
  },
  watch: {
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();
      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();
      },
      deep: true
    }
  },
  methods: {
    handleSearch() {
      this.pager.pageIndex = 1;
      this.handleGetData();
    },
    handleReset() {
      if(Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.pager.pageIndex = 1;
        this.handleGetData();
      }
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {
        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;
      })
    }
  },
  created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
